export enum EApiTokenDataGridColumns {
  name = 'name',
  user_email = 'user_email',
  issued_date = 'issued_date',
  menu = 'menu',
}
